import { createContext, useContext } from "react";

import type { ApiClient } from "../api/client";
import type { Me } from "../api/types";
import type { AuthClient } from "../auth/authClient";

export interface Session {
  auth: AuthClient;
  api: ApiClient;
  me: Me;
}

/** The React Query key the signed-in user is cached under. */
export const ME_QUERY_KEY = ["me"] as const;

export const SessionContext = createContext<Session | null>(null);

/** The signed-in session. Only available inside <SessionGate>. */
export function useSession(): Session {
  const session = useContext(SessionContext);
  if (session === null) {
    throw new Error("useSession must be used inside <SessionGate>");
  }
  return session;
}
